import { useEffect } from "react";
import "./TermsConditionsStyle.css";

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <h1 className="legal-heading">Terms & Conditions</h1>
      <div className="legal-content">
        <div className="legal-section">
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing and using Minute's website and services, you agree to be bound by these Terms and Conditions. 
            These terms apply to all visitors, users, and customers who access or use our service.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. About Minute</h2>
          <p>
            Minute is an e-commerce platform specializing in luxury, sports, and smart watches. We are based in India 
            and serve customers across North America, Europe, and Australia. Our platform connects customers with 
            high-quality timepieces from various brands.
          </p>
        </div>

        <div className="legal-section">
          <h2>3. Product Information</h2>
          <p>
            We strive to display accurate product information, including descriptions, images, and pricing. However, 
            we do not warrant that product descriptions or other content is accurate, complete, reliable, or error-free. 
            Colors, features, and specifications may vary slightly from images shown.
          </p>
        </div>

        <div className="legal-section">
          <h2>4. Pricing and Payments</h2>
          <p>
            All prices are displayed in USD and are subject to change without notice. We accept payments through 
            secure payment processors including Stripe and Razorpay. Payment is required before order processing. 
            Additional charges such as taxes, duties, or customs fees may apply based on your location.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Order Processing</h2>
          <p>
            Orders are processed within 1-2 business days. We reserve the right to refuse or cancel any order for 
            any reason, including but not limited to product availability, errors in pricing or product information, 
            or suspected fraudulent activity.
          </p>
        </div>

        <div className="legal-section">
          <h2>6. User Accounts</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials. You agree to accept 
            responsibility for all activities that occur under your account. You must notify us immediately of any 
            unauthorized use of your account.
          </p>
        </div>

        <div className="legal-section">
          <h2>7. Intellectual Property</h2>
          <p>
            The Minute platform, including its content, features, and functionality, is owned by Minute and is 
            protected by international copyright, trademark, and other intellectual property laws. You may not 
            reproduce, distribute, or create derivative works without our express written permission.
          </p>
        </div>

        <div className="legal-section">
          <h2>8. Prohibited Uses</h2>
          <p>You may not use our service:</p>
          <ul>
            <li>For any unlawful purpose or to solicit others to unlawful acts</li>
            <li>To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
            <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
            <li>To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
            <li>To submit false or misleading information</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>9. Limitation of Liability</h2>
          <p>
            In no event shall Minute, its directors, employees, or agents be liable for any indirect, incidental, 
            special, consequential, or punitive damages, including without limitation, loss of profits, data, use, 
            goodwill, or other intangible losses, resulting from your use of the service.
          </p>
        </div>

        <div className="legal-section">
          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be interpreted and governed by the laws of India. Any legal action or proceeding 
            arising under these Terms will be brought exclusively in the courts of India.
          </p>
        </div>

        <div className="legal-section">
          <h2>11. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of any material changes 
            by posting the new Terms on this page with an updated effective date. Your continued use of the service 
            after such modifications constitutes acceptance of the updated Terms.
          </p>
        </div>

        <div className="legal-section">
          <h2>12. Contact Information</h2>
          <p>
            If you have any questions about these Terms and Conditions, please contact us at:
          </p>
          <p>
            Email: legal@minute.com<br/>
            Address: Minute Legal Department, India
          </p>
        </div>

        <div className="legal-footer">
          <p><strong>Last Updated:</strong> January 2025</p>
        </div>
      </div>
    </div>
  );
};

export { TermsConditions };